__turbopack_context__.v({
  "droppableZone": "DroppableZone-module__l4Re-a__droppableZone",
});
